import { GroupStatus } from "authoring/lib/enum/group-status.mjs"
import { GroupType } from "authoring/lib/enum/group-type.mjs"
import { isLeadingSummaryGroupValid } from "../leading-summary/leading-summary-group-validation.mjs"
import { canEditGroupReferences } from "../leading-summary/can-edit-group-references.mjs"

export function isGroupValid(group, additionalChecks = {}) {
    if (group?.status !== GroupStatus.EDITING) return false
    if (group?.type === GroupType.ADD) return isValidAddGroup(group)
    if (group?.type === GroupType.OVERWRITE) return isValidOverwriteGroup(group)
    if (group?.type === GroupType.INTRODUCTION) return isValidIntroductionGroup(group)
    if (group?.type === GroupType.LEADING_SUMMARY)
        return additionalChecks.canEditReferences ? canEditGroupReferences(group) : isLeadingSummaryGroupValid(group)

    return false
}

function isValidAddGroup(group) {
    const { addTypeSchedules = [], newTasks = [] } = group ?? {}
    if (!newTasks?.length || !addTypeSchedules?.length) return false
    return true
}

function isValidOverwriteGroup(group) {
    return Boolean(group?.sourceTask && group?.similarTasks?.length)
}

function isValidIntroductionGroup(group) {
    const { introTypeSchedules = [], intro } = group ?? {}
    if (!introTypeSchedules?.length) return false
    if (!intro?.content && !intro?.note) return false
    return true
}
